var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none"
      }
    },
    [
      _c("path", {
        attrs: {
          d: "M4 7.99996L6.82843 10.8284L12.4847 5.17151",
          stroke: "#2BCAB2",
          "stroke-width": "1.33333",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2ae27d0c", { render: render, staticRenderFns: staticRenderFns })
  }
}